var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "login-bg"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center mb-4"
  }, [_c('div', {
    staticClass: "col-12 text-center"
  }, [_c('h2', {
    style: {
      color: '#fff',
      fontWeight: 'bold',
      textShadow: '2px 2px 4px rgba(0, 0, 0, 0.9)'
    }
  }, [_vm._v(" " + _vm._s(_vm.tagline) + " ")])])]), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "card rounded-lg p-4"
  }, [_c('b-row', {
    staticClass: "mt-2 ml-2"
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "pl-4 pr-5"
  }, [_c('h4', {
    staticClass: "d-flex align-items-center"
  }, [_c('router-link', {
    attrs: {
      "button": "",
      "to": "/"
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "arrow-left-short"
    }
  })], 1), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v(_vm._s(_vm.$t("loginWith.welcomeTo")) + " " + _vm._s(_vm.appName))])], 1), _c('p', [_vm._v(" " + _vm._s(_vm.$t("logintoDiscover")) + " "), _c('br'), _vm._v(" " + _vm._s(_vm.$t("newTo")) + " " + _vm._s(_vm.appName) + "? "), _c('router-link', {
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "to": "/register"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("createAccount")) + " ")])], 1)])])], 1), _c('div', {
    staticClass: "d-flex flex-column align-items-center gap-3 mt-3 mb-4"
  }, [_c('b-button', {
    staticClass: "signin-btn",
    attrs: {
      "variant": "outline-secondary"
    },
    on: {
      "click": function ($event) {
        return _vm.$router.push('/login?type=otp');
      }
    }
  }, [_c('b-icon', {
    staticClass: "me-2",
    attrs: {
      "icon": "telephone-fill"
    }
  }), _vm._v(" " + _vm._s(_vm.$t("loginWith.signWithPhone")) + " ")], 1), _c('b-button', {
    staticClass: "signin-btn",
    attrs: {
      "variant": "outline-secondary"
    },
    on: {
      "click": function ($event) {
        return _vm.$router.push('/login?type=email');
      }
    }
  }, [_c('b-icon', {
    staticClass: "me-2",
    attrs: {
      "icon": "envelope-fill"
    }
  }), _vm._v(" " + _vm._s(_vm.$t("loginWith.signWithEmail")) + " ")], 1), _c('b-button', {
    staticClass: "signin-btn google-btn",
    attrs: {
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.googleLogin
    }
  }, [_c('img', {
    staticClass: "icon-img me-2",
    attrs: {
      "src": "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg",
      "alt": "Google"
    }
  }), _vm._v(" " + _vm._s(_vm.$t("loginWith.signWithGoogle")) + " ")]), _c('b-button', {
    staticClass: "signin-btn facebook-btn",
    attrs: {
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.facebookLogin
    }
  }, [_c('img', {
    staticClass: "icon-img me-2",
    attrs: {
      "src": "https://upload.wikimedia.org/wikipedia/commons/0/05/Facebook_Logo_%282019%29.png",
      "alt": "Facebook"
    }
  }), _vm._v(" " + _vm._s(_vm.$t("loginWith.signWithFacebook")) + " ")])], 1)], 1)])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }